import React from 'react';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const info = (
  <path d="M0 12a12 12 0 1 1 12 12A12.017 12.017 0 0 1 0 12zm2 0A10 10 0 1 0 12 2 10.012 10.012 0 0 0 2 12zm7.5 7l1.358-9.1h2.93L12.431 19zm3.286-10.639a1.707 1.707 0 1 1 0.017 0z" />
);

export const arrow = (
  <path
    d="M101.054 115.443l1.822.015v-7.046h-7.16l.015 1.716 4.085.06-6.94 6.93 1.3 1.293L101 111.6z"
    transform="translate(-92.876 -108.413)"
  />
);

export const thinCaretRight = (
  <g xmlns="http://www.w3.org/2000/svg">
    <g>
      <polygon points="7.8,0.1 88.7,100 7.8,200 0,193.7 75.8,100 0,6.4   "></polygon>
    </g>
  </g>
);

export const arrowStrong = (
  <g xmlns="http://www.w3.org/2000/svg">
    <polygon points="112.3,689.9 214.9,791.4 610.8,395.4 214.9,-0.5 112.3,101 341.3,330.1 -448.9,330.1 -448.9,473.6     328.6,473.6   "></polygon>
  </g>
);

export const checkboxDefault = <path d="M2 2v20h20v-20h-20m-2-2h24v24h-24z" />;

export const checkboxSelected = (
  <>
    <path d="M0 0H24V24H0z" />
    <path
      d="M10.2 17L6 12.9l1.5-1.4 2.8 2.7 6.3-6.1 1.5 1.4z"
      fill={colors.white}
    />
  </>
);

export const x = (
  <path
    d="M78.92 62.5l-5.127 5.127L68.68 62.5l-.88.88 5.127 5.127L67.8 73.62l.88.88 5.112-5.127L78.92 74.5l.88-.88-5.127-5.112L79.8 63.38z"
    transform="translate(-67.8 -62.5)"
  />
);
export const close = (
  <path
    d="M-12839-152a16.009 16.009 0 0 1 16-16 16.005 16.005 0 0 1 16 16 16 16 0 0 1-16 16 16.006 16.006 0 0 1-16-16zm1.283 0a14.741 14.741 0 0 0 14.717 14.72 14.743 14.743 0 0 0 14.72-14.72 14.743 14.743 0 0 0-14.72-14.721 14.742 14.742 0 0 0-14.718 14.721zm14.65 1.025l-4.637 4.646-.8-.8 4.65-4.633-4.65-4.646.8-.8 4.637 4.65 4.646-4.65.8.8-4.65 4.646 4.65 4.633-.8.8z"
    transform="translate(12839.001 168)"
  />
);

export const collapse = (
  <>
    <path d="M3 2.9h26.1v26H16.5v2.9H32V0H0v16.8h3z" />
    <path d="M11.6 31.9v-2.9h-6.6L16.5 17.4 14.4 15.3l-11.4 11.4V20.5H0v11.5z" />
  </>
);

export const expand = (
  <g>
    <path
      d="M29.046 28.984H2.954V2.992h12.554V.05H0v31.877h32v-16.8h-2.954z"
      transform="translate(0 .05) translate(0 .023)"
    />
    <path
      d="M17.522.073v2.941h6.645L12.6 14.536l2.092 2.084 11.443-11.4v6.251h2.953V-.05z"
      transform="translate(0 .05) translate(2.912)"
    />
  </g>
);

export const dot = <circle cx="100" cy="100.3" r="100"></circle>;
export const caretLeft = <path d="M10 20l-10-10 10-10 3 3-6.9 7 6.9 7z" />;
export const caretRight = <path d="M3 20l10-10-10-10-3 3 6.9 7-6.9 7z" />;
export const caretDown = <path d="M0 3l10 10 10-10-3-3-7 7-7-6.9z" />;
export const caretUP = <path d="M0 10l10-10 10 10-3 3-7-6.9-7 7z" />;

export const rotate360 = (
  <g>
    <path
      d="M1.584-.383H5.5c6.583 0 6.851-5.277 6.851-6.185s-.268-6.185-6.851-6.185H1.584zm1.181-11.322H5.2c3.363 0 5.974 1.59 5.974 5.137S8.56-1.431 5.2-1.431H2.765zm13.416 0h2.5c2.486 0 2.969 1.345 2.969 2.2s-.483 2.2-2.969 2.2h-2.5zM15-.383h1.18v-5.87h2.2l3.56 5.87h1.342L19.6-6.323c1.4-.175 3.238-.821 3.238-3.18 0-3.25-3.506-3.25-4.508-3.25H15zm8.962 0H25.2l1.431-3.285h6.708l1.373 3.285h1.324l-5.331-12.37h-1.216zm8.944-4.333h-5.814l2.951-6.78zm15.4-2.341h-4.221v1.048h3.041v4.159a7.047 7.047 0 0 1-3.542.734 5.166 5.166 0 0 1-5.366-5.452 5.166 5.166 0 0 1 5.366-5.452 5.19 5.19 0 0 1 3.7 1.538l.859-.874a6.185 6.185 0 0 0-4.561-1.712 6.266 6.266 0 0 0-6.547 6.5 6.266 6.266 0 0 0 6.547 6.5 9.5 9.5 0 0 0 4.722-1.118zm12.021-.1c1.413-.751 2.826-1.5 2.826-3.285a2.716 2.716 0 0 0-2.862-2.621 2.916 2.916 0 0 0-3.184 2.813 4.888 4.888 0 0 0 1.538 2.935c-1.467.874-2.9 1.73-2.9 3.652a3.6 3.6 0 0 0 3.864 3.6 4.7 4.7 0 0 0 3.935-2.219L65.443-.3h1.592l-2.88-2.953 2.29-3.947h-1.217L63.4-3.982zM60.2-12.02a1.656 1.656 0 0 1 1.771 1.66c0 1.31-1.324 1.974-2.325 2.481a4.41 4.41 0 0 1-1.359-2.394A1.8 1.8 0 0 1 60.2-12.02zm2.629 9a3.826 3.826 0 0 1-3.041 1.9 2.638 2.638 0 0 1-2.86-2.58c0-1.468 1.27-2.219 2.4-2.883zm12.021-8.684h2.5c2.486 0 2.969 1.345 2.969 2.2s-.483 2.2-2.969 2.2h-2.5zM73.671-.383h1.181v-5.87h2.2l3.56 5.871h1.342l-3.686-5.941c1.4-.175 3.238-.821 3.238-3.18 0-3.25-3.506-3.25-4.508-3.25h-3.327zm9.785-6.185A6.266 6.266 0 0 0 90-.068a6.266 6.266 0 0 0 6.547-6.5 6.266 6.266 0 0 0-6.547-6.5 6.266 6.266 0 0 0-6.544 6.5zm1.181 0A5.166 5.166 0 0 1 90-12.02a5.166 5.166 0 0 1 5.366 5.452A5.166 5.166 0 0 1 90-1.116a5.166 5.166 0 0 1-5.364-5.452zm17.368 6.185h1.181v-11.322h4.329v-1.048h-9.838v1.048h4.329zm4.6 0h1.234l1.431-3.285h6.708l1.377 3.285h1.324l-5.331-12.371h-1.218zm8.944-4.333h-5.813l2.951-6.78zm6.547 4.333h1.181v-11.322h4.323v-1.048h-9.838v1.048h4.329zm7.459 0h8.032v-1.048h-6.851v-4.822h6.153V-7.3h-6.153v-4.4h6.564v-1.048h-7.745z"
      transform="translate(-635 -612.499) translate(633.416 673.067)"
    />
    <path
      stroke="rgba(0,0,0,0)"
      strokeMiterlimit="10"
      d="M33.2 32.242l2.438-2.449C15.837 29.579 0 24.635 0 18.565c0-4.217 7.653-7.889 18.971-9.812v2.969a62.456 62.456 0 0 0-7.328 1.71A25.233 25.233 0 0 0 4.532 16.6c-1.6 1.148-1.687 1.864-1.687 1.969s.084.818 1.687 1.969a25.194 25.194 0 0 0 7.11 3.168c6.157 1.866 14.751 3.083 24.377 3.161L33.2 24.034l1.807-1.757 5.786 5.86L35.009 34zm11.386-5.613A81.416 81.416 0 0 0 62.359 23.7a25.192 25.192 0 0 0 7.105-3.168c1.6-1.15 1.691-1.862 1.691-1.969s-.089-.82-1.691-1.969a25.231 25.231 0 0 0-7.105-3.164 60.449 60.449 0 0 0-6.384-1.53V8.922C66.772 10.881 74 14.47 74 18.565c0 5.415-12.614 9.935-29.412 11zM43.133 6.838C43.133 3.83 43.982 0 47.67 0s4.53 3.83 4.53 6.838-.854 6.84-4.534 6.84-4.533-3.831-4.533-6.84zm1.586 0c0 1.946.3 5.5 2.951 5.5s2.948-3.549 2.948-5.5-.3-5.491-2.948-5.491-2.951 3.553-2.951 5.491zM32.783 9.529a6.531 6.531 0 0 1 1.266-3.719L37.6.228h1.854l-3.588 5.51.037.038A4.085 4.085 0 0 1 41.74 9.53c0 2.578-1.944 4.148-4.475 4.148s-4.482-1.571-4.482-4.149zm1.588 0a2.892 2.892 0 0 0 5.782 0 2.893 2.893 0 0 0-5.782 0zM22.3 10.893l1.611-.523a2.451 2.451 0 0 0 2.7 1.964 2.6 2.6 0 0 0 2.724-2.6c0-1.943-1.74-2.56-3.384-2.56h-.489V5.829h.489c1.323 0 3.043-.3 3.043-2.3A2.111 2.111 0 0 0 26.7 1.347a2.571 2.571 0 0 0-2.457 1.476l-1.528-.579A4 4 0 0 1 26.589 0c2.138 0 3.991 1.179 3.991 3.458a3.215 3.215 0 0 1-2.29 3.028v.034a3.239 3.239 0 0 1 2.742 3.327c0 2.52-2.042 3.831-4.425 3.831a4.137 4.137 0 0 1-4.307-2.785zm30.647-8.222a2.7 2.7 0 1 1 2.7 2.673 2.665 2.665 0 0 1-2.7-2.673zm1.021 0a1.685 1.685 0 0 0 3.369 0 1.685 1.685 0 0 0-3.369 0z"
      transform="translate(-635 -612.499) translate(665.999 612.999)"
    />
  </g>
);

export const rotate360NoText = (
  <g>
    <path
      stroke="rgba(0,0,0,0)"
      strokeMiterlimit="10"
      d="M33.2 32.242l2.438-2.449C15.837 29.579 0 24.635 0 18.565c0-4.217 7.653-7.889 18.971-9.812v2.969a62.456 62.456 0 0 0-7.328 1.71A25.233 25.233 0 0 0 4.532 16.6c-1.6 1.148-1.687 1.864-1.687 1.969s.084.818 1.687 1.969a25.194 25.194 0 0 0 7.11 3.168c6.157 1.866 14.751 3.083 24.377 3.161L33.2 24.034l1.807-1.757 5.786 5.86L35.009 34zm11.386-5.613A81.416 81.416 0 0 0 62.359 23.7a25.192 25.192 0 0 0 7.105-3.168c1.6-1.15 1.691-1.862 1.691-1.969s-.089-.82-1.691-1.969a25.231 25.231 0 0 0-7.105-3.164 60.449 60.449 0 0 0-6.384-1.53V8.922C66.772 10.881 74 14.47 74 18.565c0 5.415-12.614 9.935-29.412 11zM43.133 6.838C43.133 3.83 43.982 0 47.67 0s4.53 3.83 4.53 6.838-.854 6.84-4.534 6.84-4.533-3.831-4.533-6.84zm1.586 0c0 1.946.3 5.5 2.951 5.5s2.948-3.549 2.948-5.5-.3-5.491-2.948-5.491-2.951 3.553-2.951 5.491zM32.783 9.529a6.531 6.531 0 0 1 1.266-3.719L37.6.228h1.854l-3.588 5.51.037.038A4.085 4.085 0 0 1 41.74 9.53c0 2.578-1.944 4.148-4.475 4.148s-4.482-1.571-4.482-4.149zm1.588 0a2.892 2.892 0 0 0 5.782 0 2.893 2.893 0 0 0-5.782 0zM22.3 10.893l1.611-.523a2.451 2.451 0 0 0 2.7 1.964 2.6 2.6 0 0 0 2.724-2.6c0-1.943-1.74-2.56-3.384-2.56h-.489V5.829h.489c1.323 0 3.043-.3 3.043-2.3A2.111 2.111 0 0 0 26.7 1.347a2.571 2.571 0 0 0-2.457 1.476l-1.528-.579A4 4 0 0 1 26.589 0c2.138 0 3.991 1.179 3.991 3.458a3.215 3.215 0 0 1-2.29 3.028v.034a3.239 3.239 0 0 1 2.742 3.327c0 2.52-2.042 3.831-4.425 3.831a4.137 4.137 0 0 1-4.307-2.785zm30.647-8.222a2.7 2.7 0 1 1 2.7 2.673 2.665 2.665 0 0 1-2.7-2.673zm1.021 0a1.685 1.685 0 0 0 3.369 0 1.685 1.685 0 0 0-3.369 0z"
      transform="translate(-665.499 -612.499) translate(665.999 612.999)"
    />
  </g>
);

export const edit = (
  <g style={{ strokeWidth: '0.2px' }}>
    <path
      strokeMiterlimit="10"
      d="M8987.457-8385.582v-1h16v1zm3.848-3h-3.848v-3.83l9.843-8.9a1.053 1.053 0 0 1 1.441.032l2.408 2.377a1.024 1.024 0 0 1 0 1.457l-.036.034-9.8 8.83zm-2.806-3.378v2.35h2.4l7.229-6.5-2.407-2.368zm7.991-7.222l2.407 2.373 1.514-1.365-2.409-2.377z"
      transform="translate(-8986.957 8402.163)"
    />
  </g>
);

export const FWD = (
  <g>
    <path
      d="M51.8 129v4.55h-5.04v-2.1H35.24v2.1H30.2V129H23v12.6h7.2v-4.55h5.04v1.4h3.96V150h3.6v-11.55h3.96v-1.4h5.04v4.55H59V129z"
      transform="translate(-23 -129)"
    />
    <path
      d="M42.081 179.7v11.55h3.959v1.4h6.48v-4.55h5.76v11.2h-5.76v-4.55h-6.48v2.1H35.96v-2.1h-6.48v4.55h-5.76v-11.2h5.76v4.55h6.48v-1.4h3.961V179.7h2.16m.72-.7H39.2v11.55h-3.96v1.4H30.2v-4.55H23V200h7.2v-4.55h5.04v2.1h11.52v-2.1h5.04V200H59v-12.6h-7.2v4.55h-5.04v-1.4H42.8V179z"
      transform="translate(-23 -129) translate(0 -15)"
    />
    <g>
      <path
        d="M34.5 164.5h4.013v1.22h-2.695v1.221h2.492v1.221h-2.492v2.338H34.5z"
        transform="translate(-23 -129) translate(31.4 154) translate(-34.5 -164.5)"
      />
      <path
        d="M41.174 164.5h1.436l.955 3.847h.017l1.25-3.847h1.225l1.241 3.949h.018l1.005-3.949h1.335l-1.749 6h-1.174l-1.317-4.153H45.4l-1.32 4.153h-1.131z"
        transform="translate(-23 -129) translate(31.4 154) translate(-36.502 -164.5)"
      />
      <path
        d="M54.619 164.5H56.6a5.661 5.661 0 0 1 1.364.161 3.118 3.118 0 0 1 1.128.521 2.546 2.546 0 0 1 .764.937 3.143 3.143 0 0 1 .284 1.4 2.853 2.853 0 0 1-.275 1.283 2.746 2.746 0 0 1-.739.933 3.249 3.249 0 0 1-1.072.571 4.134 4.134 0 0 1-1.276.2h-2.159zm1.318 4.78h.684a3.645 3.645 0 0 0 .849-.094 1.814 1.814 0 0 0 .68-.309 1.48 1.48 0 0 0 .452-.568 2.029 2.029 0 0 0 .164-.861 1.684 1.684 0 0 0-.164-.766 1.53 1.53 0 0 0-.444-.539 1.927 1.927 0 0 0-.654-.318 2.922 2.922 0 0 0-.79-.106h-.777z"
        transform="translate(-23 -129) translate(31.4 154) translate(-40.536 -164.5)"
      />
    </g>
  </g>
);

export const SH_AWD = (
  <g>
    <path
      d="M131.8 129v4.55h-5.04v-2.1h-11.52v2.1h-5.04V129H103v12.6h7.2v-4.55h5.04v1.4h3.96V150h3.6v-11.55h3.961v-1.4h5.04v4.55H139V129z"
      transform="translate(-102.676 -129) translate(-.324)"
    />
    <path
      d="M122.8 179h-3.6v11.55h-3.96v1.4h-5.04v-4.55H103V200h7.2v-4.55h5.04v2.1h11.52v-2.1h5.04V200h7.2v-12.6h-7.2v4.55h-5.04v-1.4h-3.96V179z"
      transform="translate(-102.676 -129) translate(-.324 -15)"
    />
    <g>
      <path
        d="M106.458 166.041a.963.963 0 0 0-.442-.287 1.691 1.691 0 0 0-.528-.092 1.475 1.475 0 0 0-.3.032 1.173 1.173 0 0 0-.292.1.63.63 0 0 0-.222.181.437.437 0 0 0-.086.275.445.445 0 0 0 .206.395 2 2 0 0 0 .519.235q.313.1.674.193a2.813 2.813 0 0 1 .673.275 1.557 1.557 0 0 1 .52.475 1.385 1.385 0 0 1 .206.8 1.749 1.749 0 0 1-.189.831 1.723 1.723 0 0 1-.511.589 2.238 2.238 0 0 1-.746.347 3.637 3.637 0 0 1-2-.057 2.789 2.789 0 0 1-.944-.548l.952-.985a1.385 1.385 0 0 0 .519.4 1.562 1.562 0 0 0 .648.141 1.529 1.529 0 0 0 .33-.037 1.107 1.107 0 0 0 .3-.108.642.642 0 0 0 .214-.186.442.442 0 0 0 .081-.266.476.476 0 0 0-.21-.407 2 2 0 0 0-.528-.254c-.212-.07-.44-.139-.686-.21a3.148 3.148 0 0 1-.686-.282 1.625 1.625 0 0 1-.528-.467 1.277 1.277 0 0 1-.21-.767 1.627 1.627 0 0 1 .193-.807 1.784 1.784 0 0 1 .515-.581 2.3 2.3 0 0 1 .742-.351 3.216 3.216 0 0 1 .866-.117 3.594 3.594 0 0 1 1 .137 2.327 2.327 0 0 1 .866.459z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-103 -164.5)"
      />
      <path
        d="M110.626 164.718h1.339v2.122h2.6v-2.122h1.335v5.692h-1.338v-2.46h-2.6v2.46h-1.339z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-105.116 -164.564)"
      />
      <path
        d="M121.883 170.568h-2.111v-1.024h2.111z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-107.681 -166.219)"
      />
      <path
        d="M126.169 164.718h1.106l2.643 5.692h-1.51l-.524-1.206h-2.359l-.507 1.206h-1.475zm.514 1.656l-.738 1.769h1.484z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-108.686 -164.564)"
      />
      <path
        d="M131.751 164.718h1.459l.97 3.65h.018l1.269-3.65h1.244l1.261 3.747h.018l1.021-3.747h1.356l-1.776 5.692H137.4l-1.339-3.94h-.017l-1.339 3.94h-1.149z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-110.915 -164.564)"
      />
      <path
        d="M145.058 164.718h2.008a6.108 6.108 0 0 1 1.386.152 3.3 3.3 0 0 1 1.146.495 2.463 2.463 0 0 1 .776.889 2.818 2.818 0 0 1 .288 1.327 2.56 2.56 0 0 1-.279 1.218 2.655 2.655 0 0 1-.751.885 3.385 3.385 0 0 1-1.089.542 4.486 4.486 0 0 1-1.3.185h-2.188zm1.338 4.535h.695a3.937 3.937 0 0 0 .863-.089 1.9 1.9 0 0 0 .69-.293 1.432 1.432 0 0 0 .46-.538 1.82 1.82 0 0 0 .166-.817 1.514 1.514 0 0 0-.166-.727 1.473 1.473 0 0 0-.452-.51 2.006 2.006 0 0 0-.665-.3 3.134 3.134 0 0 0-.8-.1h-.787z"
        transform="translate(-102.676 -129) translate(102.676 154) translate(-114.661 -164.564)"
      />
    </g>
  </g>
);

export const directions = (
  <g>
    <path d="M17.46,34.93L0,17.46,17.46,0,34.93,17.46ZM2.62,17.46L17.46,32.31,32.31,17.46,17.46,2.62Z" />
    <path d="M16.1,25.75V18.56h3.81v3.64L25.16,17l-5.25-5.25v3.64H16c-2.75,0-3.12,1.4-3.12,3.13v4.27Z" />
  </g>
);

export const telephone = (
  <path d="M20.54,9.44l-2.25,4c-0.59.16-1.75,0.38-1.75,0.38a9.33,9.33,0,0,0,0,8s0.9,0.18,1.83.41l2.17,4-2.81,2c-6-5.21-6-15.62,0-20.83Zm14.39,8A17.46,17.46,0,1,0,17.46,34.93,17.48,17.48,0,0,0,34.93,17.46Zm-1.89,0A15.57,15.57,0,1,1,17.46,1.89,15.59,15.59,0,0,1,33,17.46Z" />
);

export const link = (
  <path
    d="M4094-10227v-2h3a4 4 0 0 0 4-4 4 4 0 0 0-4-4h-3v-2h3a6.006 6.006 0 0 1 6 6 6.007 6.007 0 0 1-6 6zm-9 0a6.007 6.007 0 0 1-6-6 6.006 6.006 0 0 1 6-6h3v2h-3a4 4 0 0 0-4 4 4 4 0 0 0 4 4h3v2zm2-5v-2h8v2z"
    transform="translate(-4079 10239.003)"
  />
);

export const arrowLeft = (
  <path
    d="M18.241 42.1L0 21.089 18.241.1 20 1.424 2.909 21.089 20 40.776z"
    transform="translate(0 -.1)"
  />
);

export const arrowRight = (
  <path
    d="M1.759 42.1L20 21.089 1.759.1 0 1.424l17.091 19.665L0 40.776z"
    transform="translate(0 -.1)"
  />
);

export const circlePlus = (
  <path d="M100,7.1c24.8,0,48.1,9.7,65.7,27.2c17.5,17.5,27.2,40.9,27.2,65.7c0,24.8-9.7,48.1-27.2,65.7  c-17.5,17.5-40.9,27.2-65.7,27.2c-24.8,0-48.1-9.7-65.7-27.2C16.8,148.1,7.2,124.8,7.2,100c0-24.8,9.7-48.1,27.2-65.7  C51.9,16.8,75.2,7.1,100,7.1 M100,0C74.4,0,48.8,9.8,29.3,29.3c-39,39-39.1,102.4,0,141.4C48.8,190.2,74.4,200,100,200  c25.6,0,51.2-9.8,70.7-29.3c39-39.1,39.1-102.4,0-141.4C151.2,9.8,125.6,0,100,0L100,0z M103.6,50h-7.1v100h7.1V50z M150,96.4H50  v7.1h100V96.4z"></path>
);

export const circleMinus = (
  <path d="M100,7.1c24.8,0,48.1,9.7,65.7,27.2c17.5,17.5,27.2,40.9,27.2,65.7c0,24.8-9.7,48.1-27.2,65.7  c-17.5,17.5-40.9,27.2-65.7,27.2c-24.8,0-48.1-9.7-65.7-27.2C16.8,148.1,7.2,124.8,7.2,100c0-24.8,9.7-48.1,27.2-65.7  C51.9,16.8,75.2,7.1,100,7.1 M100,0C74.4,0,48.8,9.8,29.3,29.3c-39,39-39.1,102.4,0,141.4C48.8,190.2,74.4,200,100,200  c25.6,0,51.2-9.8,70.7-29.3c39-39.1,39.1-102.4,0-141.4C151.2,9.8,125.6,0,100,0L100,0z M150,96.4H50v7.1h100V96.4z"></path>
);

export const plus = (
  <path
    d="M1142.25 1133.617h-7.377l.01-7.367h-1.266v7.377l-7.367-.01v1.266l7.367-.01v7.377h1.266l-.01-7.367h7.377z"
    transform="translate(-1126.25 -1126.25)"
  />
);

export const check = (
  <path
    d="M152.663 205L147 199.482l1.982-1.931 3.681 3.586 8.355-8.137 1.982 1.93z"
    transform="translate(-147 -192.999)"
  />
);

export const plus2 = (
  <path
    d="M9194.5-8096v-6.5h-6.5v-3h6.5v-6.5h3v6.5h6.5v3h-6.5v6.5z"
    transform="translate(-9188 8112)"
  />
);

export const minus = (
  <path
    stroke="rgba(0,0,0,0)"
    d="M1142.25 1133.617h-16v1.266h16z"
    transform="translate(-1125.75 -1133.117)"
  />
);
export const magGlass = (
  <path d="M199.5,187.7l-41.1-41.1c12.9-15.5,20.7-35.4,20.7-57.1c0-49.2-40.1-89.3-89.3-89.3C40.5,0.2,0.5,40.2,0.5,89.5 s40.1,89.3,89.3,89.3c21.4,0,41-7.6,56.4-20.2l41.2,41.2L199.5,187.7z M17.6,89.5c0-39.8,32.4-72.2,72.2-72.2 c39.8,0,72.2,32.4,72.2,72.2c0,39.8-32.4,72.2-72.2,72.2C50,161.6,17.6,129.3,17.6,89.5z" />
);

export const compass = (
  <g>
    <path d="M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10s10-4.5,10-10C20,4.5,15.5,0,10,0z M10,18.9c-4.9,0-8.9-4-8.9-8.9   c0-4.9,4-8.9,8.9-8.9c4.9,0,8.9,4,8.9,8.9C18.9,14.9,14.9,18.9,10,18.9z"></path>
    <polygon points="9.5,10.5 3,10.1 15,5 9.9,17  "></polygon>
  </g>
);

export const preferredDealer = (
  <path d="M27.264 0.729v29.947l-13.264-5.631-13.264 5.631 0.019-29.947h26.51zM11.408 9.847l-6.639 0.558 5.040 4.325-1.119 4.746-0.394 1.678 5.705-3.41 5.704 3.41-0.396-1.678-1.119-4.747 5.041-4.325-6.638-0.557-2.591-6.054-2.593 6.057zM28 0h-27.982l-0.018 31.783 14-5.944 14 5.943v-31.783zM9.409 19.639l1.218-5.173-4.057-3.481 5.343-0.449 2.087-4.877 2.087 4.876 5.343 0.449-4.057 3.481 1.218 5.174-4.591-2.745-4.591 2.745z" />
);

export const preferredDealerSelected = (
  <path
    id="Path_846"
    data-name="Path 846"
    d="M.026,0,0,43.573l19.012-8.149,19.012,8.148V0Zm25.22,26.924-6.234-3.763-6.235,3.763,1.654-7.092L8.922,15.06l7.256-.616,2.834-6.686,2.834,6.685,7.256.616-5.51,4.772Z"
    fill="#e82c2a"
  />
);

export const dealerPin = (
  <path d="M14.8,0C6.6,0.1,0,6.8,0,15c0,0.1,0,0.2,0,0.4C0.1,19,1.6,22.4,4.2,25L15,35.9L25.8,25c2.5-2.5,4.1-6,4.2-9.6 c0-0.1,0-0.3,0-0.4C30,6.7,23.2-0.1,14.8,0z"></path>
);
export const dealerPin2 = (
  <path d="M111.5 82.9c-2 10.3-8.1 19.4-16.8 25.3-8.3 5.7-18.3 8.5-28.3 8-4.5-.2-8.9-1-13.2-2.5-2.7-1-5.3-2.2-7.8-3.5-7.9-4.5-14.2-11.5-17.7-19.9-4-9.9-3.6-21.1 1.1-30.7 2.4-4.9 5.8-9.2 9.9-12.7 7.1-6.1 15.9-9.8 25.2-10.6 3.4-.2 6.8-.2 10.1.1 6.6.8 12.9 3 18.5 6.4 8.9 5.3 15.4 13.7 18.2 23.7.9 3.2 1.3 6.5 1.2 9.8.2 2.2 0 4.4-.4 6.6zm23.6-21.1C129 39 111.3 21.1 88.6 14.6c-7.8-2.2-15.9-3.2-24-2.8C40.8 13 19.3 26.3 7.7 47.1 1.4 58.6-1.2 71.8.5 84.8c2.6 17.6 14.5 40.7 34.9 67.7 5.3 7 12 15.2 18.2 22.4 4.5 5.2 10.8 12.1 12.7 13.9.4.5.8.8 1.4 1 .8.3 1.7.2 2.4-.3 1.1-.8 9.1-9.6 15-16.5 27.3-31.7 45-60.8 50.3-82.1 1.2-4.5 1.8-9.1 1.7-13.8 0-5.2-.7-10.4-2-15.3z"></path>
);
export const redo = (
  <path
    d="M3.072 2.857A5.212 5.212 0 0 1 6.9 1.333a5.607 5.607 0 0 1 3.843 1.538 5.562 5.562 0 0 1 1.478 2.872L9.468 4.271l-.643 1.173 4.7 2.513 2.62-4.641-1.179-.649L13.5 5.333a6.979 6.979 0 0 0-1.79-3.39l-.01-.014-.015-.014A6.966 6.966 0 0 0 6.9 0a6.568 6.568 0 0 0-4.811 1.943 6.723 6.723 0 0 0 0 9.447l.011.01.015.014a6.932 6.932 0 0 0 9.567 0l-.925-.971a5.57 5.57 0 0 1-7.7.013 5.4 5.4 0 0 1 .014-7.6z"
    transform="translate(-0.15)"
  />
);

export const ilxLogo = (
  <path d="M10.792 31.926H-6.229L-6.428-.225h17.021l.199 32.151zM108.44 25.854v6.371H29.007c-4.479 0-8.262-2.986-9.556-7.067-.398-1.195-.398-2.688-.498-4.579L18.754-.026h17.021l.1 20.207c0 .498 0 .995.199 1.493.796 2.389 3.285 4.181 5.972 4.181h66.393zM200.216 31.926h-23.193l-20.505-10.053-20.605 10.053H112.82L145.17 16 112.521-.026h23.093l21.003 10.352L177.62-.026h22.994l-32.749 16.225 32.35 15.727z"></path>
);

export const integraLogo = (
  <path d="M12.3.9H0v32.6h12.3V.9zM33.3 6.8c.7-.2 1.5 0 2.1.5 2.2 1.6 20.2 15.1 32 23.4 4.1 2.9 4.8 2.8 10 2.8h12V1h-9v25.2c-.6 0-1.2-.2-1.7-.5-.9-.6-18.9-14.4-26.7-20C45.8 1.2 43.1 1 37.8 1H24.3v32.4h9V6.8zM97.1 5.8h28.6v27.7h12.9V5.8h28.5V.9h-70zM178.5 33.5h43.7c3 0 7.4 0 10.4-.2 1.1 0 2.2-.3 3.1-.9.7-.5 4.6-4.2 4.6-4.2h-46.2c-4.2 0-6-1.5-6-5.2v-4h48.6l-.1-5h-48.5V5.8h51.3V.9c-2.5-.1-61.7 0-61.7 0h-2.3v29.6c0 2.5.6 3 3.1 3zM300.9.9c7 .1 9.3.5 10.9 1.9.9.8 1.6 1.9 2 3h-43.1c-1.6 0-3.3 0-4.8.1-4.3.3-6.6 4.3-6.7 10.6-.1 5.5 2.1 11 6.6 11.6 1.4.2 3.2.2 4.2.2h22.7c4.2 0 6-1.5 6-5.2v-3.9h-19.1v-4.9h32v16.5c0 2.6-.1 2.7-2.5 2.7h-40.6c-2.7 0-6.8 0-9.8-.2-8.2-.6-12.2-9.3-12.2-16.9.1-8.4 4.2-14.9 12.2-15.2 4.5-.2 4.8-.2 10.5-.2 0-.1 31.7-.1 31.7-.1zM334.6 5.8h32.5c3.4 0 3.7 0 4.9.1 4.1.3 3.7 9-.4 9h-29.9L365 29.8c5.6 3.2 6.4 3.7 12.8 3.7h12.6L368.1 20h8.7c1.5 0 1.6 0 3-.1 10-.2 10.6-18.5.6-18.9-2.5-.1-3.5-.1-6.7-.1h-52v32.6h12.9V5.8zM428.2.9h-3c-3.7 0-5.9.6-8.3 3.6-.5.6-1 1.2-1.9 2.3l-19.6 26.6h11.9l5.7-7.9h40.6l7.6 7.9h15.6L445.1.9h-16.9zm-11.7 19.5l6.9-9.5c.3-.5 1.4-2 2.1-2.8 1-1.5 2.8-2.3 4.5-2.2h4.9l13.6 14.5h-32z"></path>
);

export const tlxLogo = (
  <path d="M47.8 7.2l.1 26.2H30.7l-.1-26.2H0V.8h79.2v6.4H47.8zM176.2 27v6.4H95.9c-4.5 0-8.4-3-9.7-7.1-.4-1.2-.4-2.7-.5-4.6L85.6.8h17.2l.1 20.4c0 .5 0 1 .2 1.5.8 2.4 3.3 4.2 6 4.2h67.1v.1zM269 33.3h-23.4l-20.8-10.2L204 33.3h-23.3l32.7-16.1L180.3.8h23.3l21.2 10.5L246.1.8h23.3l-33.1 16.4L269 33.3z"></path>
);

export const rdxLogo = (
  <path d="M89.9 33.4H70.5L58.2 20.2H25.8v-6.4h44.7c1 0 2.1-.7 2.1-1.8l-.1-2.8c0-.1 0-.5-.1-.7-.3-.9-1.1-1.5-2-1.5H17.2l.1 26.2H.2L0 .9h83.6c2.7 0 5 1.8 5.8 4.2.3 1 .3 1.8.3 1.8l.1 7.8c0 3-2.9 5.6-6.1 5.6h-6.1l12.3 13.1zM189.7 23.1c0 5.6-4.5 10.2-10.1 10.2H99L98.8.9h80.6c4.6 0 8.4 2.9 9.8 7.1.3 1 .5 2 .5 3.1v12zm-17.3-9.2c0-.7-.1-1.7-.3-2.4-.8-2.5-3.2-4.2-5.8-4.2H116l.1 19.8h50.2c3.3 0 6.2-2.4 6.2-5.6l-.1-7.6zM280.4 33.4H257l-20.8-10.2-20.8 10.2h-23.3l32.7-16.1L191.7.8H215l21.2 10.5L257.5.8h23.3l-33.1 16.4 32.7 16.2z"></path>
);

export const mdxLogo = (
  <path d="M97.7.9l.2 32.5H80.6l-.1-22.1-25.4 22H36.3L8.7 11.1l.1 22.3H.2L0 .9h17L49.4 27 79.4.9h18.3zM197.4 23.2c0 5.6-4.5 10.2-10.1 10.2h-80.6L106.4.9H187c4.6 0 8.4 2.9 9.8 7.1.3 1 .5 2 .5 3.1l.1 12.1zM180.1 14c0-.7-.1-1.7-.3-2.4-.8-2.5-3.2-4.2-5.8-4.2h-50.3l.1 19.8H174c3.3 0 6.2-2.4 6.2-5.6l-.1-7.6zM288.1 33.3h-23.4l-20.8-10.2-20.8 10.2h-23.3l32.7-16.1L199.4.9h23.3l21.2 10.5L265.1.9h23.3l-33.1 16.4 32.8 16z"></path>
);
export const location = (
  <g>
    <path d="M111.5,82.9c-2,10.3-8.1,19.4-16.8,25.3c-8.3,5.7-18.3,8.5-28.3,8c-4.5-0.2-8.9-1-13.2-2.5       c-2.7-1-5.3-2.2-7.8-3.5c-7.9-4.5-14.2-11.5-17.7-19.9c-4-9.9-3.6-21.1,1.1-30.7c2.4-4.9,5.8-9.2,9.9-12.7       c7.1-6.1,15.9-9.8,25.2-10.6c3.4-0.2,6.8-0.2,10.1,0.1c6.6,0.8,12.9,3,18.5,6.4c8.9,5.3,15.4,13.7,18.2,23.7       c0.9,3.2,1.3,6.5,1.2,9.8C112.1,78.5,111.9,80.7,111.5,82.9z M135.1,61.8C129,39,111.3,21.1,88.6,14.6c-7.8-2.2-15.9-3.2-24-2.8       C40.8,13,19.3,26.3,7.7,47.1C1.4,58.6-1.2,71.8,0.5,84.8c2.6,17.6,14.5,40.7,34.9,67.7c5.3,7,12,15.2,18.2,22.4       c4.5,5.2,10.8,12.1,12.7,13.9c0.4,0.5,0.8,0.8,1.4,1c0.8,0.3,1.7,0.2,2.4-0.3c1.1-0.8,9.1-9.6,15-16.5c27.3-31.7,45-60.8,50.3-82.1       c1.2-4.5,1.8-9.1,1.7-13.8C137.1,71.9,136.4,66.7,135.1,61.8z"></path>
  </g>
);

export const infoI = (
  <>
    <path d="M1.9 7H6L4.1 20H0z"></path>
    <circle cx="4.6" cy="2.4" r="2.4"></circle>
  </>
);

export const clock = (
  <>
    <path d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm0,21A10,10,0,1,1,21,11,10,10,0,0,1,11,21Z"></path>
    <polygon points="12 11.59 12 3 10 3 10 14 11.71 14.71 17.71 8.71 16.29 7.29 12 11.59"></polygon>
  </>
);

export const blackRookLogo = (
  <>
    <title>Powered by Black Book</title>
    <path
      fillRule="evenodd"
      d="M159.5,70 C162.234825,70 164,72.2783462 164,74.9997043 C164,77.7222452 162.234825,80 159.5,80 C156.765175,80 155,77.7222452 155,74.9997043 C155,72.2783462 156.765175,70 159.5,70 Z M121,71.5 C121,72.5636085 120.269394,73 118.980818,73 L117,73 L117,70 L118.980818,70 C120.115374,70 121,70.4363915 121,71.5 Z M119.622941,76 C120.975592,76 122,76.5809809 122,77.9996846 C122,79.4190191 120.975592,80 119.622941,80 L117,80 L117,76 L119.622941,76 Z M142,54 L144,49 L146,54 L142,54 Z M112,49.4994884 C112,50.5636085 111.269394,51 109.980818,51 L108,51 L108,48 L109.980818,48 C111.115374,48 112,48.4363915 112,49.4994884 Z M138.5,70 C141.234825,70 143,72.2783462 143,74.9997043 C143,77.7222452 141.234825,80 138.5,80 C135.765175,80 134,77.7222452 134,74.9997043 C134,72.2783462 135.765175,70 138.5,70 Z M184.291206,59.3020233 L187.4771,59.3020233 L181.305202,52.1677264 L186.796298,45.2744729 L183.789717,45.2744729 L178.780121,51.5668816 L178.780121,45.2744729 L176.375562,45.2744729 L176.375562,59.3020233 L178.780121,59.3020233 L178.780121,52.9696367 L184.291206,59.3020233 Z M181.488043,81.7513952 L184.674524,81.7513952 L178.502039,74.6170983 L183.993723,67.7226689 L180.987142,67.7226689 L175.976958,74.0156656 L175.976958,67.7226689 L173.572398,67.7226689 L173.572398,81.7513952 L175.976958,81.7513952 L175.976958,75.4184206 L181.488043,81.7513952 Z M163.837167,59.5424788 C167.384039,59.5424788 169.22773,57.1585007 169.22773,57.1585007 L167.624495,55.5746692 C167.624495,55.5746692 166.302281,57.2984235 163.837167,57.2984235 C161.07163,57.2984235 159.167972,54.9938134 159.167972,52.2882481 C159.167972,49.5826829 161.07163,47.2780727 163.837167,47.2780727 C166.141782,47.2780727 167.404028,48.8213384 167.404028,48.8213384 L169.02784,47.2380948 C169.02784,47.2380948 167.204138,45.0328416 163.837167,45.0328416 C159.788807,45.0328416 156.722847,48.1399499 156.722847,52.2882481 C156.722847,56.4359584 159.788807,59.5424788 163.837167,59.5424788 Z M159.444291,81.9918507 C163.532041,81.9918507 166.538622,78.8853303 166.538622,74.737032 C166.538622,70.5887338 163.532041,67.4822134 159.444291,67.4822134 C155.355952,67.4822134 152.349959,70.5887338 152.349959,74.737032 C152.349959,78.8853303 155.355952,81.9918507 159.444291,81.9918507 Z M148.353335,59.3020233 L150.777883,59.3020233 L145.326765,45.2744729 L142.88164,45.2744729 L137.43111,59.3020233 L139.855658,59.3020233 L141.138482,55.9756243 L147.070511,55.9756243 L148.353335,59.3020233 Z M138.221851,81.9918507 C142.309602,81.9918507 145.316183,78.8853303 145.316183,74.737032 C145.316183,70.5887338 142.309602,67.4822134 138.221851,67.4822134 C134.134101,67.4822134 131.128108,70.5887338 131.128108,74.737032 C131.128108,78.8853303 134.134101,81.9918507 138.221851,81.9918507 Z M122.409964,59.3020233 L130.787119,59.3020233 L131.530827,57.0174022 L124.814523,57.0174022 L124.814523,45.2744729 L122.409964,45.2744729 L122.409964,59.3020233 Z M119.404559,81.7513952 C122.050162,81.7513952 124.094331,80.0676188 124.094331,77.602509 C124.094331,75.0774324 122.110129,74.3560659 121.910239,74.316088 C122.110129,74.2561211 123.372964,73.4342218 123.372964,71.7310444 C123.372964,68.7850237 121.188871,67.7226689 118.903658,67.7226689 L114.354397,67.7226689 L114.354397,81.7513952 L119.404559,81.7513952 Z M105.813215,59.3020233 L110.862789,59.3020233 C113.508392,59.3020233 115.552561,57.6188349 115.552561,55.1531372 C115.552561,52.6286484 113.568359,51.9078699 113.367881,51.867304 C113.568359,51.8073371 114.831193,50.9854379 114.831193,49.2816726 C114.831193,46.3362397 112.646513,45.2744729 110.361888,45.2744729 L105.813215,45.2744729 L105.813215,59.3020233 Z M193.978816,31 L210,96 L102.020596,96 L86,31 L193.978816,31 Z M110.622941,53 C111.975592,53 113,53.5804416 113,54.9993691 C113,56.4195584 111.975592,57 110.622941,57 L108,57 L108,53 L110.622941,53 Z"
      transform="translate(-86 -31)"
    ></path>
  </>
);

export const circledCheck = (
  <polygon
    fillRule="evenodd"
    points="82.5,158.9 27,103.4 36.9,93.5 82.5,139.1 176.3,45.3 186.2,55.2 "
  ></polygon>
);

export const longDealerPin = (
  <path d="M0 12.7273C-3.18893e-07 17.8313 3.27866 23.2723 6.48685 27.5067C9.69504 31.7411 12.9052 34.7673 12.9052 34.7673C13.2347 35.0776 13.7685 35.0776 14.0979 34.7673C14.0979 34.7673 17.3081 31.7411 20.5163 27.5067C23.7245 23.2723 27 17.8313 27 12.7273C27 5.70773 20.9457 0 13.5 0C6.05426 0 4.78339e-07 5.70773 0 12.7273Z" />
);

export const filledTelephone = (
  <g>
    <path
      d="M14.477 1.00046C11.8115 1.00046 9.20584 1.79058 6.98956 3.27145C4.77328 4.75233 3.04591 6.85719 2.02587 9.31979C1.00583 11.7824 0.738953 14.4921 1.25897 17.1064C1.77898 19.7207 3.06253 22.122 4.94732 24.0068C6.83211 25.8916 9.23349 27.1753 11.8478 27.6953C14.4621 28.2153 17.1719 27.9482 19.6345 26.9282C22.0971 25.9081 24.2019 24.1811 25.6827 21.9648C27.1636 19.7485 27.954 17.1425 27.954 14.477C27.954 10.9027 26.5341 7.47515 24.0067 4.94772C21.4793 2.4203 18.0513 1.00046 14.477 1.00046Z"
      strokeWidth="0.5"
    />
    <path
      d="M11.2939 14.6492C11.3276 17.4821 12.4162 20.2008 14.347 22.2742C14.4059 22.3356 14.4855 22.3734 14.5704 22.3796C14.6554 22.3859 14.7396 22.3604 14.8069 22.3083L16.613 20.925C16.6807 20.8733 16.727 20.7984 16.7429 20.7146C16.7587 20.6308 16.7431 20.5444 16.699 20.4714L15.1299 17.8782C15.0988 17.8266 15.0548 17.7844 15.0021 17.7551C14.9495 17.7258 14.8902 17.7105 14.83 17.7112H13.9579C13.9015 17.7115 13.8459 17.6983 13.7958 17.6721C13.7458 17.646 13.7029 17.6078 13.671 17.5613C12.9361 15.6885 12.9361 13.6069 13.671 11.7341C13.703 11.6877 13.7459 11.6502 13.7959 11.6243C13.8459 11.5983 13.9016 11.5847 13.9579 11.5852H14.83C14.8902 11.5859 14.9495 11.571 15.0021 11.5417C15.0548 11.5125 15.0988 11.4697 15.1299 11.4182L16.699 8.82543C16.7429 8.7524 16.7584 8.66551 16.7425 8.58178C16.7266 8.49805 16.6806 8.42324 16.613 8.37133L14.8069 6.98803C14.7396 6.93584 14.6552 6.91076 14.5702 6.91723C14.4852 6.92369 14.4057 6.9614 14.347 7.02319C12.4159 9.0968 11.3274 11.8158 11.2939 14.6492Z"
      fill="white"
    />
  </g>
);

export const filledDirections = (
  <g opacity="0.96">
    <rect
      x="13.4351"
      width="19"
      height="19"
      rx="2"
      transform="rotate(45 13.4351 0)"
    />
    <path
      d="M12.3477 18.8216V13.264H15.3208V16.0776L19.4175 12.0581L15.3208 8V10.8136H12.2696C10.1237 10.8136 9.83496 11.8958 9.83496 13.233V16.5336L12.3477 18.8216Z"
      fill="white"
    />
  </g>
);

export const pathPin = (
  <path d="M0 12.7273C-3.18893e-07 17.8313 3.27866 23.2723 6.48685 27.5067C9.69504 31.7411 12.9052 34.7673 12.9052 34.7673C13.2347 35.0776 13.7685 35.0776 14.0979 34.7673C14.0979 34.7673 17.3081 31.7411 20.5163 27.5067C23.7245 23.2723 27 17.8313 27 12.7273C27 5.70773 20.9457 0 13.5 0C6.05426 0 4.78339e-07 5.70773 0 12.7273Z" />
);

export const chat = (
  <g>
    <path d="M12.0063 20.2478C11.0879 18.9103 10.2135 17.6777 9.38532 16.408C9.19871 16.078 8.84436 15.8923 8.47742 15.936C7.03903 15.96 5.60274 15.9469 4.16435 15.9469C2.88113 15.936 2.25 15.2781 2.25 13.9647L2.25 5.73219C2.25 4.3947 2.88113 3.75 4.15177 3.75L19.9027 3.75C21.1084 3.75 21.75 4.40781 21.75 5.66444V14.0106C21.75 15.2563 21.1084 15.925 19.9027 15.925C18.4434 15.936 16.9945 15.9491 15.5331 15.9141C15.1682 15.8704 14.8118 16.0562 14.6273 16.3862C13.7969 17.6668 12.9226 18.8994 12.0063 20.25V20.2478ZM11.9958 11.2657C12.7695 11.2635 13.3923 10.6079 13.3902 9.80146C13.3881 8.99503 12.759 8.34596 11.9853 8.34815C11.2116 8.35033 10.5889 9.00596 10.591 9.81238C10.591 10.6166 11.2179 11.2679 11.9895 11.2657C11.9895 11.2657 11.9937 11.2657 11.9958 11.2657ZM8.58855 9.79053C8.58435 8.98411 7.95532 8.33503 7.18371 8.33722C6.41 8.34159 5.78726 8.99722 5.78935 9.80146C5.79355 10.6079 6.42258 11.257 7.19419 11.2548C7.20258 11.2548 7.20887 11.2548 7.21726 11.2548C7.97629 11.2548 8.59065 10.6101 8.58855 9.81894C8.58855 9.8102 8.58855 9.79927 8.58855 9.79053ZM16.7848 8.35033C16.009 8.36344 15.3905 9.03 15.4031 9.83861C15.4156 10.6472 16.0552 11.2919 16.831 11.2788C17.6068 11.2657 18.2253 10.6013 18.2127 9.79272C18.2127 8.99722 17.5963 8.35252 16.8331 8.35033C16.8184 8.35033 16.8016 8.35033 16.7869 8.35033H16.7848Z" />
  </g>
);

export const email = (
  <g>
    <g>
      <path d="M22.75 19.2266L22.75 9.66582L14.508 16.4513C14.3482 16.5816 14.1905 16.6152 13.9978 16.6152C13.8051 16.6152 13.6475 16.5501 13.4876 16.4513L5.25 9.66582L5.25 19.2266C5.25 19.6824 5.60035 20.0417 6.04486 20.0417L21.9551 20.0417C22.3997 20.0417 22.75 19.6824 22.75 19.2266Z" />
      <path d="M6.10836 8.29614L14 14.7561L21.8916 8.29614L6.10836 8.29614Z" />
      <path d="M19.1874 4.77049L14.0001 0.791687L8.81487 4.77049V4.80417H11.6133V6.98892L16.3868 6.98892V4.80417L19.1874 4.80417V4.77049Z" />
    </g>
  </g>
);

export const phone = (
  <path d="M19.3567 14.4C19.302 14.3567 15.3333 11.496 14.244 11.7013C13.724 11.7933 13.4267 12.148 12.83 12.858C12.734 12.9727 12.5033 13.2473 12.324 13.4427C11.9469 13.3197 11.5791 13.17 11.2233 12.9947C9.38701 12.1007 7.90333 10.617 7.00933 8.78067C6.83391 8.42495 6.68419 8.05712 6.56133 7.68C6.75733 7.5 7.032 7.26933 7.14933 7.17067C7.856 6.57733 8.21133 6.28 8.30333 5.75867C8.492 4.67867 5.63333 0.682667 5.60333 0.646667C5.47363 0.461381 5.30437 0.307242 5.10778 0.195402C4.9112 0.0835624 4.69221 0.0168188 4.46667 0C3.308 0 0 4.29133 0 5.014C0 5.056 0.0606667 9.32533 5.32533 14.6807C10.6753 19.9393 14.944 20 14.986 20C15.7093 20 20 16.692 20 15.5333C19.9834 15.3086 19.917 15.0903 19.8058 14.8943C19.6945 14.6983 19.5411 14.5295 19.3567 14.4Z" />
);

export const checkMark = (
  <g>
    <circle cx="12" cy="12" r="12" fill="#128559" fillOpacity="0.8" />
    <g>
      <mask
        id="mask0_1781_5577"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="16"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3.99951H19.5214V19.5712H4V3.99951Z"
        />
      </mask>
      <g mask="url(#mask0_1781_5577)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3768 5.53386C16.0612 5.85052 15.7454 6.16749 15.4255 6.48853C15.4143 6.48205 15.3985 6.47422 15.384 6.46438C14.5995 5.93008 13.7412 5.58241 12.8046 5.42716C12.3432 5.35068 11.879 5.32517 11.4139 5.35175C10.1706 5.42283 9.03465 5.81416 8.02598 6.54961C6.69492 7.52012 5.84556 8.81364 5.4868 10.4275C5.37964 10.9095 5.32963 11.3985 5.34321 11.8914C5.39229 13.6722 6.04936 15.1912 7.32471 16.4315C8.21625 17.2986 9.28012 17.8495 10.4968 18.0987C11.0603 18.2141 11.6309 18.2557 12.2044 18.2095C14.0302 18.0623 15.5378 17.2842 16.7146 15.8784C17.4435 15.0076 17.895 14.0006 18.0907 12.88C18.1163 12.7339 18.1293 12.5856 18.1505 12.4387C18.1538 12.4159 18.1655 12.3901 18.1816 12.374C18.6068 11.9458 19.0332 11.5186 19.4594 11.0914C19.464 11.0869 19.4702 11.084 19.4885 11.0716C19.5801 12.1115 19.4826 13.1231 19.1672 14.1083C18.5515 16.0317 17.3741 17.5164 15.6322 18.5264C12.1841 20.5256 7.75342 19.5942 5.41861 16.2586C3.08174 12.9202 3.69051 8.3864 6.81347 5.79154C9.86092 3.2594 13.9303 3.63157 16.3768 5.53386Z"
          fill="white"
        />
      </g>
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91211 10.8229C7.38812 10.3635 7.87577 9.89292 8.36369 9.42209C9.53004 10.5475 10.7101 11.6862 11.8908 12.8254C14.2804 10.5194 16.66 8.22314 19.0325 5.93359C19.5294 6.41309 20.0172 6.88379 20.5003 7.35008C17.7209 10.0323 14.708 12.9433 11.9141 15.6395"
    />
  </g>
);

export const enlarge = (color: string = 'white') => (
  <>
    <g clipPath="url(#clip0_1636_3230)" fill="transparent">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.507 3.47977H3.3418V25.5198H24.507V3.47977Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2535 22.0398V20.8798H8.58524L12.2931 17.0188L11.5054 16.1986L7.79768 20.0597V16.2398H6.68372V22.0398H12.2535ZM15.5954 6.95978V8.11978H19.2637L15.5558 11.9808L16.3435 12.801L20.0512 8.9399V12.7598H21.1652V6.95978H15.5954Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1636_3230">
        <rect
          width="28"
          height="29"
          fill="white"
          transform="translate(0 -0.000244141)"
        />
      </clipPath>
    </defs>
  </>
);

export const roundedCaretLeft = (
  <path
    d="M5 1L1 4.50162L5 8"
    stroke="#007CC0"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
